import React, { forwardRef, useState } from 'react';
import candado from '../../images/candado.svg'
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import mail from '../../images/mail.svg'
import { useTranslation } from 'react-i18next';

const SendEmail = forwardRef(({ setOpen, setSendMail, ...props }, ref) => {
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        maxWidth: 600,
        bgcolor: 'background.paper',
        border: '1px solid #000',
        borderColor: 'white',
        boxShadow: 24,
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent:'center',
        alignItems: 'center'
      };

    const handleClose = (event) => {
        setOpen(false)
        setSendMail(false)
    }

    return (
        <Box ref={ref} sx={style} {...props}>
            <img src={mail} alt="Bandeja de entrada" height="40px" width="40px"></img> 
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{fontFamily:'patua one', textAlign:'center'}}>
                {t("recoverPass.screenReview.title")}
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2, textAlign:'center' }}>
                {t("recoverPass.screenReview.description")}
            </Typography>
            <Button
                onClick={handleClose}
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2, textTransform: 'none', fontFamily: 'Patua One, sans-serif', fontSize: '18px', }}
                disabled={loading}
            >
                {t("recoverPass.screenReview.accept")}
            </Button>
        </Box>
    )
})

export default SendEmail;